import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordForm } from '@/features/auth/forgot-password'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 */
export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordForm,
})
